{
  "Sign In - EventLive": "ログイン - EventLive",
  "Forgot Password - EventLive": "パスワードをお忘れの場合 - EventLive",
  "Password Restore Link Sent - EventLive": "パスワード再設定リンクを送信しました - EventLive",
  "Event": "イベント",
  "Event Details": "イベントの詳細",
  "Details": "詳細",
  "How to Go Live": "ライブ配信の方法",
  "Multi-Camera": "マルチカメラ",
  "Add a room": "ルームを追加",
  "Guest List": "ゲストリスト",
  "Import Guests": "ゲストをインポート",
  "Add a Guest": "ゲストを追加",
  "Event Analytics": "イベントの分析",
  "Purchase Successful": "購入が完了しました",
  "Test EventLive": "EventLiveをテスト",
  "Schedule Event": "イベントの予定を設定",
  "Download everything": "すべてダウンロード",
  "Update Email": "メールアドレスを変更",
  "Help Us Grow": "応援のお願い",
  "Set a New Password - EventLive": "新しいパスワードを設定 - EventLive",
  "Are you sure?": "よろしいですか？",
  "Could not load data. Please check your internet connection. Ensure the timezone, date and time on your device are correct.": "データを読み込めませんでした。インターネット接続を確認してください。また、デバイスのタイムゾーンと日付・時刻が正しいことを確認してください。",
  "Couldn't save your profile": "プロフィールを保存できませんでした",
  "Link required": "リンクは必須です",
  "Overview": "概要",
  "{days}-Day Event: {start} – {end}": "{days}日間のイベント：{start}〜{end}",
  "Close event": "イベントを閉じる",
  "This sign-in link has expired": "このログインリンクは有効期限が切れています",
  "Couldn't sign you in from this link": "このリンクからログインできませんでした",
  "Please sign in to continue.": "続けるにはログインしてください。",
  "Couldn't save your changes": "変更を保存できませんでした",
  "TEST": "テスト",
  "Download EventLive for Mac": "Mac版EventLiveをダウンロード",
  "Download for": "ダウンロード",
  "People": "メンバー",
  "Team invite - EventLive": "チームへの招待 - EventLive"
}
